import React from "react";
import { createRoot } from "react-dom/client";
import Results from "./Results";

const searchContainer = document.getElementById("search-results");
if (searchContainer) {
  const resultsRoot = createRoot(searchContainer);
  resultsRoot.render(<Results />);
}
